export default "/kiban/_next/static/images/rfContactPortionCnt-46654b64e54069c59b81273922e9dced.png";